import React, {useEffect, useRef, useState} from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getAllHomepageSections, SaveHomepageSectionDisplayOrder } from '../../../Services/AdminServices';
import { SectionData } from './SectionCard';

export function useManageHomepageSections() {
    
    const [sectionsData, setSectionsData] = useState<SectionData[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    function _fatchData(callback: Function = ()=>{}){
        setIsLoading(true);
        getAllHomepageSections(false).then((response)=>{
            setIsLoading(false);
            callback((response.data as any ).sections);
        }).catch((error)=>{
            setIsLoading(false);
            console.log(error);
        });
    }

    function saveOrder(){
        // re-write all order number and save.
        for(let i=0;i<sectionsData.length;i++){
            sectionsData[i].displayOrder = i;
        }
        let newData= [...sectionsData];
        setSectionsData(newData);
        SaveHomepageSectionDisplayOrder(newData).then((response)=>{
            console.log(response);
            toastSuccessMessage('All changes saved.');
        });
    }
    function toastSuccessMessage(message: string) {
        Swal.fire({
            icon: 'success',
            position: 'top-end',
            title: 'Success',
            text: message,
            timer: 5000,
            toast: true,
            timerProgressBar: true,
            showConfirmButton: false,
            showCancelButton: false,
        })
    }

    useEffect(() => {
        _fatchData((newData:any)=>{
            setSectionsData([...newData]);
        });
    }, []);

    return [sectionsData, isLoading, setSectionsData, saveOrder] as const;
}